import { Injectable } from '@angular/core';
import { LivekitService } from '../../development/livekit.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, share, switchMap, withLatestFrom } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as SharedActions from '@states/shared/shared.actions';
import { AppState } from '../app.state';
import { UtilsService } from '../../edge/utils.service';
import { LiveKitActions } from '@states/live-kit/live-kit.action-types';

@Injectable()
export class LiveKitEffects {


  public getLiveKitRoomList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LiveKitActions.getLiveKitRoomList),
      switchMap(() => {
        return this.liveKitService
          .getListAllRooms()
          .pipe(
            switchMap(res => {
              return [
                LiveKitActions.getLiveKitRoomListSuccess({ servers: res.servers, summary: res.summary }),
                LiveKitActions.setInitialLoader({ loading: false }),
              ];
            }),
            catchError(err => {
              const errMsg = this.utilsService.errMessage(err);
              return [
                LiveKitActions.setInitialLoader({ loading: false }),
                SharedActions.consoleMessage({ error: errMsg }),
              ];
            }),
          );
      }),
      share(),
    ),
  );

  public removeLiveKit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LiveKitActions.removeLiveKit),
      withLatestFrom(
        this.store$.pipe(select(state => state.liveKitState)),
      ),
      switchMap(([{ room, server }, liveKitState]) => {
        return this.liveKitService
          .deleteRoomByName(room.name)
          .pipe(
            switchMap(res => {
              const indexToDelete = server.rooms.findIndex(item => item.name === room.name);
              const newServer = {
                ...server,
                rooms: server.rooms.filter((_, i) => i !== indexToDelete),
              };
              return [
                LiveKitActions.removeLiveKitSuccess({ server: newServer }),
                SharedActions.showMessage({ success: 'Room has been removed' }),
              ];
            }),
            catchError(err => {
              const errMsg = this.utilsService.errMessage(err);
              return [
                SharedActions.consoleMessage({ error: errMsg }),
              ];
            }),
          );
      }),
      share(),
    ),
  );


  constructor(private liveKitService: LivekitService,
              private actions$: Actions,
              private store$: Store<AppState>,
              private utilsService: UtilsService) {

  }

}
